"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var operators_1 = require("rxjs/operators");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var CompareInteractionsModal_1 = require("../CompareInteractionsModal");
var Tree_1 = require("../../components/Tree");
var CompareInteractionsNotification = /** @class */ (function (_super) {
    __extends(CompareInteractionsNotification, _super);
    function CompareInteractionsNotification(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleCompareInteractionsModal = function () {
            if (!_this.state.previousInteractionLoaded) {
                _this.getData();
            }
            _this.setState(function (prevState) { return ({
                showComparedInteractions: !prevState.showComparedInteractions
            }); });
        };
        _this.state = {
            showComparedInteractions: false,
            previousInteractionLoaded: false
        };
        return _this;
    }
    CompareInteractionsNotification.prototype.render = function () {
        var interaction = this.props.interaction;
        var _a = this.state, showComparedInteractions = _a.showComparedInteractions, previousInteractionLoaded = _a.previousInteractionLoaded, previousInteraction = _a.previousInteraction, popupMessage = _a.popupMessage;
        return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(CompareInteractionsModal_1.default, { showComparedInteractions: showComparedInteractions, interactionsLoaded: previousInteractionLoaded, firstInteraction: previousInteraction, secondInteraction: interaction, fallbackMessage: popupMessage, hideComparedInteractions: this.toggleCompareInteractionsModal }), (0, jsx_runtime_1.jsx)("a", { className: "d-block text-primary on-hover-underline", onClick: this.toggleCompareInteractionsModal, children: "Compare interaction to previous version" })] }) }));
    };
    CompareInteractionsNotification.prototype.getData = function () {
        var _this = this;
        var policyPreviousVersionNumber;
        var couldGetData;
        if (this.props.interaction.status === "PENDING_RENEWAL" || this.props.interaction.status === "UNDERWRITING_FAILURE") {
            policyPreviousVersionNumber = this.props.interaction.agreementVersion;
            couldGetData = true;
        }
        else {
            policyPreviousVersionNumber = (Number(this.props.interaction.agreementVersion) - 1).toString();
            couldGetData = !!this.props.policyVersions.find(function (policyVersion) {
                return (policyVersion.policyVersionNumber === policyPreviousVersionNumber);
            });
        }
        if (couldGetData) {
            this.setState({ popupMessage: "Loading..." });
            this.supportPortalService
                .getPolicyVersionDetails(this.props.interaction.userReference, this.props.interaction.agreementNumber, policyPreviousVersionNumber)
                .subscribe(function (policyVersion) {
                _this.supportPortalService.getInteraction(policyVersion.interactionId).pipe((0, operators_1.finalize)(function () { return _this.setState({ previousInteractionLoaded: true }); }))
                    .subscribe(function (previousInteraction) {
                    _this.setState({ previousInteraction: previousInteraction });
                });
            });
        }
        else {
            this.setState({ popupMessage: "Could not get data for version " + policyPreviousVersionNumber });
        }
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], CompareInteractionsNotification.prototype, "supportPortalService", void 0);
    CompareInteractionsNotification = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], CompareInteractionsNotification);
    return CompareInteractionsNotification;
}(React.Component));
exports.default = CompareInteractionsNotification;
//# sourceMappingURL=CompareInteractionsNotification.js.map